import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import * as S from "../svg.style";
export var MagnifyingGlassMinus = function(_param) /*#__PURE__*/ {
    var color = _param.color, height = _param.height, width = _param.width, shrinkable = _param.shrinkable, rest = _object_without_properties(_param, [
        "color",
        "height",
        "width",
        "shrinkable"
    ]);
    return _jsx(S.Svg, _object_spread_props(_object_spread({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        height: height || "21",
        width: width || "20",
        viewBox: "0 0 20 21",
        shrinkable: shrinkable
    }, rest), {
        children: /*#__PURE__*/ _jsx("path", {
            d: "M14.4492 14.4805L21.5 21.5273M6 9.51562H13M16.5 9.5C16.5 13.3672 13.3672 16.5 9.5 16.5C5.63281 16.5 2.5 13.3672 2.5 9.5C2.5 5.63281 5.63281 2.5 9.5 2.5C13.3672 2.5 16.5 5.63281 16.5 9.5Z",
            stroke: color || "#0D0D0D",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    }));
};
